import AlarmService from "@/services/alarm.service.js";
import AlarmFormatter from "@/helpers/formatters/alarm.formatter.js";

class AlarmRepository {

    async getAlarmTypes() {
        const res = await AlarmService.getAlarmTypes();
        return AlarmFormatter.alarmTypesFormat(res.data);
    }

    async getBaliseAlarms(baliseId, offset, limit, startDate = null, endDate = null, alarmTypeIds = null) {
        const res = await AlarmService.getBaliseAlarms(
            baliseId,
            offset,
            limit,
            startDate,
            endDate,
            alarmTypeIds
        );
        return AlarmFormatter.alarmsSearchFormat(res.data);
    }

    async search(filters = {}) {
        const res = await AlarmService.searchAlarms(filters);
        return AlarmFormatter.alarmsSearchFormat(res.data);
    }

}

export default new AlarmRepository();
